/** 
 * 工具方法
 * 命名：大驼峰写法
 * */
import echarts from "echarts";
import { style, geoCoordMap } from "@/js/assets.js";

let geoJSON = require("@/assets/data/china.json");
echarts.registerMap("china", geoJSON); // 注册地图，名为china

// let cityJSON = require("@/assets/data/city_code.json");
// 将cityJSON转为一元数组
// let plainList = [];
// function plain(list) {
//   list.map(item => {
//     for(let key in item) {
//       let val = item[key];
//       if(val instanceof Array) {
//         plain(val);
//       }else {
//         plainList.push({
//           name: item.name,
//           code: item.code.slice(0, 2)
//         })
//       }
//     }
//   })
// }

/****************** 登录 ******************/
/** 获取token */
export const getToken = function () {
    // if(getFromLocal('ifRemember') && getFromLocal("token")) {
    //     return getFromLocal("token")
    // }else if(!getFromLocal('ifRemember') && getFromSession("token")) {
    //     return getFromSession('token')
    // }else {
    //     return false;
    // }
    if (getFromLocal('token')) {
        return getFromLocal('token');
    } else {
        return false;
    }
}

/** 登录存储 */
export const Login = function () {

}

/** 登录检查
 *  已登录返回true
 */
export const checkLogin = function () {
    return !!getFromSession('login') && !!getToken()
}

/** 读取存储 */
export const getFromLocal = function (name) {
    return JSON.parse(JSON.stringify(localStorage.getItem(name))); // 不存在将返回null
}
export const getFromSession = function (name) {
    return JSON.parse(JSON.stringify(sessionStorage.getItem(name)))
}

/** 筛选按钮
 *  点击筛选按钮，必须至少选择一个
 *  dataName object，状态名、属性名；key String，键名
 */
export const Filter = function (dataName, key) {
    let data = this[dataName]; // 引用赋值
    let temp = { ...data }; // 拷贝
    let no_true = true; // 是否都不选
    temp[key] = !temp[key];
    for (key in temp) {
        if (temp[key]) no_true = false;
    }
    if (no_true) {
        // 此次点击会导致全都不选，所以不做修改
        return false; // 返回操作状态false
    }
    try {
        this[dataName] = { ...temp }; // 修改状态
        return true; // 返回操作状态true
    } catch (err) {
        err
    }
}

/****************** 报表 ******************/

export const getWatermarkOption = function(watermarkText = '武汉行舟') {
    const watermark = [];
    const rows = 4;
    const cols = 6;
    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
            watermark.push({
                type: 'text',
                left: `${(j + 0.5) * (100 / cols)}%`,
                top: `${(i + 0.5) * (100 / rows)}%`,
                style: {
                    text: watermarkText,
                    fill: 'rgba(0, 0, 0, 0.06)',
                    fontSize: 12,
                    fontWeight: 'bold'
                },
                rotation: Math.PI / 4,
                z: 100
            });
        }
    }
    return watermark;
};

/** 折线图
 * id 容器id
 * data 数据
 * config： {
 *  title: 报表标题，必须
 *  option: 额外配置项，必须提供标题
 * }
 */
export const Line = function (id, data, config) {
    let charts;
    if (echarts.getInstanceByDom(document.getElementById(id))) {
        charts = echarts.getInstanceByDom(document.getElementById(id)); // 获取已初始化的echarts对象
    } else {
        charts = echarts.init(document.getElementById(id)); // DOM元素初始化为echarts对象
    }
    let colorList = ["#f26828", "#5c74f5", "#85cf96"]; // 颜色表
    const watermarkText = config.watermarkText || '武汉行舟';
    charts.setOption({
        title: {
            text: config.title,
            left: "center",
            // textAlign: 'center'
            textStyle: {
                fontSize: translateWidth(16, 'font')
            }
        },
        tooltip: {
            trigger: "axis",
        },
        legend: {
            data: data.legend,
            bottom: 0,
            icon: "circle",
            itemGap: translateWidth(50),
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8)
        },
        grid: {
            left: "5%",
            right: "5%",
            bottom: "20%",
            // width: "700",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                offset: 16,
                axisTick: {
                    show: true,
                    alignWithLabel: true,
                    lineStyle: {
                        color: "#b8bac9"
                    }
                },
                axisLine: {
                    lineStyle: {
                        opacity: 0 // 不显示轴线
                    }
                },
                axisLabel: {
                    color: "#b8bac9" // 刻度标签样式
                },
                boundaryGap: false,
                data: data.xData
            }
        ],
        yAxis: [
            {
                type: "value",
                offset: 16,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        opacity: 0 // 不显示轴线
                    }
                },
                axisLabel: {
                    color: "#b8bac9" // 刻度标签样式
                }
            }
        ],
        series: data.valueData.map((item, key) => {
            return {
                name: data.legend[key],
                type: "line",
                //   stack: "总量",
                //   areaStyle: {
                //     color: colorList[key], // 填充颜色
                //     opacity: 0.2
                //   },
                itemStyle: {
                    color: colorList[key] // 线的颜色
                },
                data: item
            };
        }),
        graphic: getWatermarkOption(watermarkText),
        ...config.option
    });
    return charts;
}
/** 饼图
 * id 容器id
 * data 数据
 * config： {
 *  title: 报表标题，必须
 *  option: 额外配置项，必须提供标题
 * }
 */
export const Pie = function (id, data = [], config = {}) {
    let charts;
    if (echarts.getInstanceByDom(document.getElementById(id))) {
        charts = echarts.getInstanceByDom(document.getElementById(id)); // 获取已初始化的echarts对象
    } else {
        charts = echarts.init(document.getElementById(id)); // DOM元素初始化为echarts对象
    }
    const watermarkText = config.watermarkText || '武汉行舟';
    charts.setOption({
        title: {
            text: config.title,
            top: translateWidth(50),
            left: "center",
            right: "center",
            textStyle: {
                fontSize: translateWidth(16, 'font')
            }
        },
        backgroundColor: "#fff",
        // 鼠标移到图形上的提示框
        tooltip: {
            trigger: "item",
            formatter: "{a} {b}: {c} ({d}%)"
        },
        // 图例配置
        legend: {
            orient: "vertical",
            align: "left",
            // x: "right",
            y: "middle",
            // top: "20%",
            right: "10%",
            icon: "circle",
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8),
            itemGap: translateWidth(20),
            data: data.map(item => item.name),
            formatter: function (name) {
                let target;
                let per;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].name === name) {
                        target = data[i].value;
                        per = data[i].per;
                    }
                }
                return (
                    "{a|" + name + "}{c|￥}{b|" + target + "}" + "{d|" + per + "}"
                );
            },
            textStyle: {
                rich: {
                    a: {
                        width: 60,
                        fontSize: translateWidth(14, 'font'),
                        color: "#949494",
                        padding: translateWidth([10, 10, 10, 4])
                    },
                    b: {
                        padding: translateWidth([0, 10, 0, 0]),
                        fontSize: translateWidth(24, 'font'),
                        color: "#000",
                        height: translateWidth(28),
                        verticalAlign: "top",
                        shadowColor: "#b00",
                        shadowBlur: 10,
                        shadowOffsetX: 20,
                        shadowOffsetY: 10
                    },
                    d: {
                        fontSize: translateWidth(14, 'font'),
                        color: "#949494"
                    }
                }
            }
        },
        // 图形颜色表
        color: style.pie_color_list,
        // 系列，指图形
        series: [
            {
                name: "",
                type: "pie",
                radius: ["20%", "25%"], // 内外径
                center: ["30%", "50%"],
                label: {
                    normal: {
                        formatter: "{d}%", // 延伸标签格式，d：比率
                        color: "#949494"
                    }
                },
                labelLine: {
                    length: translateWidth(20), // 延伸线1长度
                    length2: translateWidth(30) // 延伸线2长度
                },
                data: data
            }
        ],
        graphic: getWatermarkOption(watermarkText),
        ...config.option // 展开额外option
    });
    return charts;
}
/** 柱状图
 * 
 */
export const Bar = function (id, data, config = {}) {
    let colorList = config.colorList ? config.colorList : ["#f26828", "#5c74f5", "#85cf96", "#ffb74a"];
    let charts;
    if (echarts.getInstanceByDom(document.getElementById(id))) {
        charts = echarts.getInstanceByDom(document.getElementById(id)); // 获取已初始化的echarts对象
    } else {
        charts = echarts.init(document.getElementById(id)); // DOM元素初始化为echarts对象
    }
    const watermarkText = config.watermarkText || '武汉行舟';
    charts.setOption({
        title: {
            text: config.title || "",
            top: translateWidth(20),
            left: "center",
            // right: "center",
            textStyle: {
                fontSize: translateWidth(16, 'font')
            }
        },
        tooltip: {
            trigger: "axis", // 鼠标悬停展示详情
            axisPointer: {
                type: "none" // 取消鼠标悬停柱条标线
            }
        },
        legend: {
            data: data.legend,
            bottom: 0,
            icon: "circle",
            itemGap: translateWidth(20),
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8)
        },
        // 网格
        grid: {
            top: "20%",
            left: "4%",
            right: "4%",
            // bottom: 0,
            height: translateWidth(260),
            containLabel: true // grid区域包含刻度标签，防刻度标签文字溢出
            // width: "100%" // 图形宽度
        },
        // y轴
        yAxis: {
            // splitNum: 2,
            // minInterval: 30000, // 坐标轴最小间隔数值，可以动态计算来决定标线数量
            type: "value",
            offset: 20,
            axisLine: {
                lineStyle: {
                    opacity: 0 // 不显示轴线
                }
            },
            axisTick: {
                show: false // 不显示刻度
            },
            axisLabel: {
                color: "#b8bac9" // 刻度标签样式
            },
        },
        // x轴
        xAxis: {
            type: "category",
            offset: 20,
            boundaryGap: true,
            axisLine: {
                lineStyle: {
                    opacity: 0 // 不显示轴线
                }
            },
            axisTick: {
                show: true,
                alignWithLabel: true,
                length: 6,
                lineStyle: {
                    color: "b8bac9"
                }
            },
            axisLabel: {
                color: "#b8bac9"
            },
            data: data.xArray

        },
        series: data.valueData.map((item, key) => {
            return {
                name: data.legend[key],
                type: "bar", // 柱图
                barWidth: translateWidth(10), // 柱条宽度
                itemStyle: {
                    color: colorList[key], // 柱条颜色
                    barBorderRadius: 50 // 柱条圆角
                },
                emphasis: {
                    itemStyle: {
                        // color: "#05b8fe" // 鼠标悬停时柱条颜色
                    }
                },
                data: item
            }
        }),
        graphic: getWatermarkOption(watermarkText),
        ...config.option
    });
    return charts;
}

/** 地图
 * data { legend, datas, style }
 * legend 图例名称数组，如 ['一线城市', '二线城市', '三线城市']
 * datas  系列数组，如 [ [], [], [] ]
 * style  各系列样式配置，如 [{}, {}, {}]
 */
export const MAP = function (id, data, config = {}) {
    var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
                let obj = {
                    name: data[i].name,
                    value: geoCoord.concat(data[i].value)
                }
                res.push(obj);
            }
        }
        return res;
    };
    let charts;
    if (echarts.getInstanceByDom(document.getElementById(id))) {
        charts = echarts.getInstanceByDom(document.getElementById(id)); // 获取已初始化的echarts对象
    } else {
        charts = echarts.init(document.getElementById(id)); // DOM元素初始化为echarts对象
    }
    const watermarkText = config.watermarkText || '武汉行舟';
    let option = {
        backgroundColor: "#fff",
        title: {
            text: config.title,
            // text: "参保城市统计图",
            // subtext: 'data from PM25.in', // 副标题
            // sublink: 'http://www.pm25.in', // 副标题链接
            left: "center",
            top: translateWidth(20),
            textStyle: {
                fontSize: translateWidth(16, 'font'),
                color: "#000"
            }
        },
        tooltip: {
            show: false,
            trigger: "item"
        },
        legend: {
            orient: "vertical",
            y: "bottom",
            x: "center",
            data: data.legend,
            textStyle: {
                color: "#000"
            },
            selectedMode: false
        },
        geo: {
            map: "china", // 地图注册时的名称
            top: translateWidth(260),
            zoom: translateWidth(1.4), // 缩放
            // scaleLimit: {
            //   min: 1.4,
            //   max: 1.4
            // }, // 缩放限制
            label: {
                emphasis: {
                    show: false
                }
            },
            // roam: true, // 开启鼠标缩放和平移
            itemStyle: {
                normal: {
                    areaColor: "#f3f3f3", // 填充色
                    borderColor: "#fff", // 边框色
                    borderWidth: 1.4
                },
                emphasis: {
                    areaColor: "#f3f3f3" // 高亮填充色
                }
            },
            // 特定区域样式
            regions: [
                // {
                //     name: "湖南省",
                //     itemStyle: {
                //         areaColor: "#5c74f5"
                //     }
                // }
            ],
            silent: true
        },
        series: data.datas.map((item, key) => {
            return {
                name: data.legend[key],
                type: "scatter", // 散点图
                coordinateSystem: "geo", // 散点类型，地理坐标
                data: convertData(item), // 散点数据
                symbol: "pin",  //  标识符号类型
                symbolSize: translateWidth(24), // 标识符号大小
                hoverAnimation: true, // 取消鼠标移入动画
                // silent: true, // 不响应鼠标事件
                label: {
                    normal: {
                        formatter: "{b}",
                        position: "bottom",
                        show: true,
                        padding: translateWidth([3, 7, 1, 7]),
                        fontSize: 12,
                        color: "#fff",
                        backgroundColor: "rgba(100, 100, 100, 0.9)",
                        borderRadius: 10
                    },
                    emphasis: {
                        show: true
                    }
                },
                itemStyle: {
                    normal: {
                        color: "#f26828",
                        opacity: 1
                    }
                },
                ...(data.style[key]) // 对应系列的样式
            }
        }),
        graphic: getWatermarkOption(watermarkText),
        ...config.option
    };
    charts.setOption(option);

    return charts;
}

/** echarts报表图片下载
 *  id 容器id，必须
 *  title 下载文件名
 *  customerShortName 企业简称（可选）
 */
export const downloadPic = function (id, title, customerShortName = '') {
    // 获取当前日期，格式：YYYYMMDD
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const dateStr = year + month + day;
    
    // 构建文件名：名称-企业简称-当前年月日
    let fileName = title;
    if (customerShortName) {
        fileName = `${title}-${customerShortName}-${dateStr}`;
    } else {
        fileName = `${title}-${dateStr}`;
    }
    
    // 获取画布图表地址信息
    const imgUrl = echarts.getInstanceByDom(document.getElementById(id)).getDataURL({
        type: "png",
        pixelRatio: 1,
        backgroundColor: "#fff"
    });
    // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
    if (window.navigator.msSaveOrOpenBlob) {
        // 截取base64的数据内容（去掉前面的描述信息，类似这样的一段：data:image/png;base64,）并解码为2进制数据
        let bstr = atob(imgUrl.split(",")[1]);
        // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
        let n = bstr.length;
        // 创建一个Uint8Array类型的数组以存放二进制数据
        let u8arr = new Uint8Array(n);
        // 将二进制数据存入Uint8Array类型的数组中
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        // 创建blob对象
        let blob = new Blob([u8arr]);
        // 调用浏览器的方法，调起IE的下载流程
        window.navigator.msSaveOrOpenBlob(blob, fileName + ".png");
    } else {
        //类似chrome浏览器创建一个a标签并使用a标签的href属性下载
        let tempA = document.createElement("a");
        tempA.download = fileName + ".png";
        tempA.href = imgUrl;
        document.body.appendChild(tempA);
        tempA.click();
        tempA.remove();
    }
    // this[dataName] = echarts.getInstanceByDom(document.getElementById(id)).getDataURL({
    //     pixelRatio: 1, // 图片缩放
    //     backgroundColor: '#fff'
    // })
}

/****************** 转换方法 ******************/

/** 日期转换
 * date 日期字符串或Date对象
 * config 配置，格式：
 * {
 *   format  格式字符串
 * }
 *  */
export const dateConvert = function (date, config) {
    // typeof config; // 预留参数
    if(!date) {
        return 
    }

    let d = new Date(date);
    let YEAR = d.getFullYear();
    let MONTH = d.getMonth() + 1;
    let DATE = d.getDate();
    let HOUR = d.getHours();
    let MIN = d.getMinutes();
    let SEC = d.getSeconds();

    if (MONTH < 10) MONTH = "0" + MONTH;
    if (DATE < 10) DATE = "0" + DATE;
    if (HOUR < 10) HOUR = "0" + HOUR;
    if (MIN < 10) MIN = "0" + MIN;
    if (SEC < 10) SEC = "0" + SEC;

    let format = "Y-M-D"; // 默认
    if (config && config.format) {
        format = config.format;
    }
    format = format.replace("Y", YEAR);
    format = format.replace("M", MONTH);
    format = format.replace("D", DATE);
    format = format.replace("H", HOUR);
    format = format.replace("MIN", MIN);
    format = format.replace("S", SEC);
    // let formatted = `${YEAR}-${MONTH}-${DATE} ${HOUR}:${MIN}:${SEC}`;

    return format;
}

/** 时间区间审查
 * date Date对象
 * config 配置项，可选
 * 季度审查时，起始月为1、4、7、10且结束月为3、6、9、12时返回true
 * 年度审查时，起始月为 1时返回true
 */
export const zoneCheck = function (date, config) {
    let month = date.getMonth();
    let quarter_start = [0, 3, 6, 9]; // 季度起始月份1,4,7,10
    let quarter_end = [2, 5, 8, 11]; // 季度结束月份3,6,9,12
    config = {
        type: "quarter", // 默认为季度审查, "year" || "quarter" || "month"
        length: 1200, // 最大周期数
        // selected: 0,  // Date对象，已选择的月份，不默认，不传则认为尚无已选
        ...config
    }
    // if (!config) {
    //     config = {
    //         type: "quarter", // 默认为季度审查, "year" || "quarter" || "month"
    //         length: 1200, // 最大周期数
    //         // selected: 0,  // Date对象，已选择的月份，不默认，不传则认为尚无已选
    //     }
    // }

    if (config.type === "year") {
        if (!config.selected) {
            // 未选择，只能选择年度的起点和终点
            return (month == 0 || month == 11);
        } else {
            let selected_month = config.selected.getMonth();
            // 已选择1个时间点，判断已选的是年度起点或终点
            // 计算限制范围
            
            if (selected_month == 0) {
                // 根据已选时间、最大周期数限制可选区间大小
                // code....
                return (month == 11 && date > config.selected);
            } else {
                return (month == 0 && date < config.selected);
            }
        }
    } else if (config.type === "quarter") {
        if (!config.selected) {
            // 未选择，只能选择季度的起点和终点
            return (quarter_start.includes(month) || quarter_end.includes(month));
        } else {
            let selected_month = config.selected.getMonth();
            // 已选择1个时间点，判断已选的是季度起点或终点
            if (quarter_start.includes(selected_month)) {
                return (quarter_end.includes(month) && date > config.selected);
            } else {
                return (quarter_start.includes(month) && date < config.selected);
            }
        }
    } else {
        if (!config.selected) {
            // 未选择
            return false;
        } else {
            let selected_month = config.selected.getMonth();
            // 已选择1个时间点
            if (quarter_start.includes(selected_month)) {
                return (quarter_end.includes(month) && date > config.selected);
            } else {
                return (quarter_start.includes(month) && date < config.selected);
            }

        }
    }
}

/**
 * 初始化时间区间，默认6个月
 * cycle: 'm'月度 'q'季度 'y'年度
 * num: 周期数
 * precision 截止时间是否精确到日，'d'精确到日，默认到月
 * setCurrent 手动设置的当前时间
 */
export const initZone = function (cycle = 'm', num = 6, precision, setCurrent) {
    let current = setCurrent ? setCurrent : new Date();
    let YEAR = current.getFullYear(); // 当前年份
    let MONTH = current.getMonth() + 1; // 当前月份，从1开始
    let DATE = current.getDate(); // 当前日期

    let year = YEAR;
    let month = MONTH;

    num = num - 1; // 区间包含当前周期
    switch (cycle) {
        case 'm':
            month = MONTH - num;
            break;
        case 'q':
            month = MONTH - num * 3;
            break;
        case 'y':
            month = MONTH - num * 12;
            break;
        default:
            break;
    }
    if (month < 1) {
        year = YEAR - Math.abs(Math.floor(month / 12))
        month = 12 + (month % 12)
    }
    if (month < 10) {
        month = "0" + month;
    }
    if (MONTH < 10) {
        MONTH = "0" + MONTH;
    }
    if (DATE < 10) {
        DATE = "0" + DATE;
    }

    let start = new Date(`${year}-${month}`);
    let end = precision === 'd' ? new Date(`${YEAR}-${MONTH}-${DATE}`) : new Date(`${YEAR}-${MONTH}`);

    return [start, end];
}

/** 小数转百分比
 * point 待转换的值
 * num 小数点位数
 */
export const toPercent = function (point, num) {
    if (point === 0) return point;
    if (point === '') return point;
    var str = Number(point * 100).toFixed(num);
    if (isNaN(str)) return 0;
    str += "%";
    return str;
}

/** 金额格式
 * s 金额，Number/String
 * n 保留n位小数
 */
export const moneyFormat = function (s, n) {
    if (!s && s != 0) return 0
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat(s + "").toFixed(n) + "";
    let l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
}

/** 获取组织名称
 * value: 当前选择的值，必须
 * options：可选项数组，必须
 * config：配置键值对名称，可选
 */
export const labelOfValue = function (value, options, config) {
    let optionsKey = "label";
    let optionsValue = "value";
    if (config) {
        optionsKey = config.optionsValue;
        optionsValue = config.optionsKey;
    }
    let item = options.find(item => {
        return item[optionsValue] === value;
    });
    if (item) {
        return item[optionsKey];
    } else {
        return "";
    }
}

/**
 * 限制上传文件
 * size 文件大小，单位为mb
 */
export const limitUpload = function (file, size) {
    // const isJPG = file.type === 'image/jpeg';
    const isLtSize = file.size / 1024 / 1024 < size;

    // if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG 格式!');
    // }
    // if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!');
    // }
    return isLtSize;
}

/**
 * 相对1920分辨率等比转换
 */
export const translateWidth = function (number, type) {
    // 使用window.innerWidth代替document.body.clientWidth，更准确反映窗口宽度
    const windowWidth = window.innerWidth || document.body.clientWidth;
    // 限制最大宽度为2560（1920的约1.33倍），防止缩放时尺寸过大
    const maxWidth = 2560;
    const actualWidth = Math.min(windowWidth, maxWidth);
    
    if (number instanceof Array) {
        return number.map((number) => {
            let result = (number / 1920) * actualWidth;
            // 根据类型设置不同的限制
            if (type === 'font') {
                // 字体大小限制
                if (result < 12) result = 12;
                if (result > 20) result = 20;
            } else if (type === 'button') {
                // 按钮尺寸限制
                if (result > 150) result = 150;
            } else {
                // 其他元素的尺寸限制
                if (result > 180) result = 180;
            }
            return result
        })
    } else {
        let result = (number / 1920) * actualWidth;
        // 根据类型设置不同的限制
        if (type === 'font') {
            // 字体大小限制
            if (result < 12) result = 12;
            if (result > 20) result = 20;
        } else if (type === 'button') {
            // 按钮尺寸限制
            if (result > 150) result = 150;
        } else {
            // 其他元素的尺寸限制
            if (result > 180) result = 180;
        }
        return result
    }
}

/** 检测ie */
export const checkIE = function () {
    return (!!window.ActiveXObject || "ActiveXObject" in window)
}